import axios from 'axios';

export default async function getAllLocationAccessLevelProfilesByUser({
  accessToken,
  userId,
  page = 0,
  pageSize = 10,
  query = '',
}) {
  try {
    const requestOptions = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    const { data } = await axios.get(
      `${process.env.REACT_APP_LOCATION_ACCESS_LEVEL_PROFILE_API_URL}/user/${userId}?page=${page}&pageSize=${pageSize}&query=${query}`,
      requestOptions,
    );

    return data;
  } catch (err) {
    return null;
  }
}
